<template>
    <div :data-component="$options.name">
        <p
            data-jest-text
            class="mb-16 text-text-l"
        >
            {{ getText() }}
        </p>
        <div class="w-full h-4 mb-8 overflow-hidden rounded bg-alabaster">
            <div
                :class="getColorClass()"
                :style="{ width: getWidthPercentage() }"
                class="h-4 rounded"
                data-jest-bar
            />
        </div>
        <span>{{ currentStep }} von {{ numberOfSteps }}</span> {{ text }}
    </div>
</template>
<script lang="ts" src="./MsProgressBar.ts" />
